import { render } from "./VCalendarUi_NEW.vue?vue&type=template&id=47525da3"
import script from "./VCalendarUi_NEW.vue?vue&type=script&lang=js"
export * from "./VCalendarUi_NEW.vue?vue&type=script&lang=js"

import "./VCalendarUi_NEW.vue?vue&type=style&index=0&id=47525da3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__